import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-message-box-invite',
  templateUrl: './message-box-invite.component.html',
  styleUrls: ['./message-box-invite.component.css']
})
export class MessageBoxInviteDialog {

  message: any;
  invitations: any;
  errors: any;

  constructor(public dialogRef: MatDialogRef<MessageBoxInviteDialog>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
                this.invitations = data.data.invitations;
                this.errors = data.data.errors;
              }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/message-box-invite/message-box-invite.component.ts